module.exports = __webpack_public_path__ + "static/media/Offset-printing Icon.908709b6.png";